module.exports = __webpack_public_path__ + "static/gender_card_img1@2x-fa670b8d1808302dd63712474d8c0bda.jpg";